import {
   Box,
   Button,
   Paper,
   Table,
   TableBody,
   TableCell,
   TableContainer,
   TableHead,
   TableRow,
   Typography,
} from '@mui/material';

import { ExportToCsv } from 'export-to-csv';
import { useEffect, useMemo, useState } from 'react';
import Loading from '../../Loading';

import { uid } from 'uid';

const PreviewTable = ({ loadedData, processing }) => {
   const [exportData, setExportData] = useState(false);
   const [exportHeaders, setExportHeaders] = useState(false);
   const [exportDisabled, setExportDisabled] = useState(true);
   useEffect(() => {
      if (loadedData && loadedData.length > 0) {
         loadExportFile(loadedData);
      }
   }, [loadedData]);

   async function loadExportFile(data) {
      let headers = ['name', 'date', 'time', 'action', 'location'];

      setExportHeaders(headers);
      const dataToExport = data.map((item) => ({
         name: item.name,
         date: item.date,
         time: item.time,
         action: item.action,
         location: item.location,
      }));
      setExportData(dataToExport);
      setExportDisabled(false);
   }

   const dataToExport = useMemo(() => exportData, [exportData]);
   const dataExportId = useMemo(() => uid(16), []); // create a unique and identifyable ID for each file downloaded

   const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: `ITO-status-export-${dataExportId}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: false,
      headers: exportHeaders,
   };

   const csvExporter = new ExportToCsv(options);

   return (
      <Box>
         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Box>
               <Typography variant="h5" gutterBottom>
                  Export Preview
               </Typography>
            </Box>
            <Box>
               <Button
                  variant="contained"
                  onClick={() => csvExporter.generateCsv(dataToExport)}
                  disabled={exportDisabled}
               >
                  Export
               </Button>
            </Box>
         </Box>
         {processing && <Loading />}
         {!loadedData && (
            <Typography variant="body1">Select your report parameters</Typography>
         )}
         {loadedData && loadedData.length === 0 && (
            <Typography variant="body1">Nothing to display</Typography>
         )}
         {loadedData && loadedData.length > 0 && (
            <TableContainer component={Paper}>
               <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="Export Table"
                  stickyHeader
               >
                  <TableHead>
                     <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Date</TableCell>
                        <TableCell align="right">Time</TableCell>
                        <TableCell align="right">Action</TableCell>

                        <TableCell align="right">Location</TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {console.log(loadedData, 'loadedData in table')}
                     {loadedData.map((person, idx) => (
                        <TableRow
                           key={`${idx}`}
                           sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                           }}
                        >
                           <TableCell component="th" scope="row">
                              {person.name}
                           </TableCell>
                           {/* <TableCell align="right" sx={{ maxWidth: 100 }}>
                                    {person.groups.map((group) => (
                                       <Chip key={group} label={group} size="small" />
                                    ))}
                                 </TableCell> */}
                           <TableCell align="right">{person.date}</TableCell>
                           <TableCell align="right">{person.time}</TableCell>
                           <TableCell align="right">{person.action}</TableCell>
                           <TableCell align="right">{person.location}</TableCell>
                        </TableRow>
                     ))}
                  </TableBody>
               </Table>
            </TableContainer>
         )}
      </Box>
   );
};

export default PreviewTable;
